import React from 'react';
import { Badge } from '@allygpo/ally-ux';

/** Numbered upload steps used by both Setup bulk-upload tabs. The step number is Ally UX's Badge. */
export const UploadSteps: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <ol className="setup-steps list-none u-m-0 u-p-0">{children}</ol>
);

interface UploadStepProps {
  n: number;
  title: React.ReactNode;
  children?: React.ReactNode;
  /** Controls under the text, e.g. a download button or the drop zone. */
  action?: React.ReactNode;
}

export const UploadStep: React.FC<UploadStepProps> = ({ n, title, children, action }) => (
  <li className="setup-step flex u-gap-4 u-py-4">
    <Badge value={n} variant="primary" className="flex-none" aria-hidden="true" />
    <div className="flex flex-column u-gap-2 align-items-start flex-1 min-w-0">
      <div className="setup-step-text flex flex-column u-gap-2px">
        <span className="text-sm font-semibold text-default">{title}</span>
        {children && <span className="setup-step-desc text-xs text-secondary leading-normal">{children}</span>}
      </div>
      {action}
    </div>
  </li>
);
